/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
export {AnimationModule,Animation,AUTO_STYLE,AnimationGroupMetadata,AnimationKeyframesSequenceMetadata,AnimationSequenceMetadata,AnimationStateMetadata,AnimationStyleMetadata,AnimationTransitionMetadata,animate,group,keyframes,sequence,state,style,transition,AnimationTrigger,trigger} from './src/animation';
